module.exports = __webpack_public_path__ + "img/sk_payments_guide.18a73ec5.jpg";